import PerfectScrollbar from "react-perfect-scrollbar";

// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";

export default function DialogMonitorPedidosPI({ erro, handleClose }) {
  const close = () => {
    handleClose();
  };

  return (
    <>
      <Dialog
        maxWidth="lg"
        open
        onClose={close}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>
          <span>
            <Typography id="alert-dialog-title" variant="h3" component="h3">
              {`Erro gerado na Integração do Pedido`}
            </Typography>
          </span>
        </DialogTitle>
        <PerfectScrollbar>
          <DialogContent style={{ padding: "2rem 3rem", overflowX: "hidden" }}>
            <Grid container style={{ wordBreak: "break-word" }}>
              <Grid item xs={12}>
                {erro}
              </Grid>
            </Grid>
          </DialogContent>
        </PerfectScrollbar>
        <DialogActions>
          <Button component={Box} onClick={handleClose}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
